
const AppContext: any = {};

export default AppContext;